export type AccessLevel = 'administrator' | 'manager' | 'trainer' | 'learner' | 'authenticated' | 'anonymous';
